export const getStyleValueForPrefix = (inlineStyles, prefix) => {
  const styleValue = inlineStyles.find(item => item.includes(prefix));
  return styleValue ? styleValue.replace(prefix, '') : null;
};